import { useRef } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { Skeleton } from "primereact/skeleton";
import { connect } from "react-redux";

import * as actions from "../../store/actions/index";
import { withRouter } from "../../shared/utility";
import EmptyModal from "../../components/modals/EmptyModal";
import PackagingBarcodeLookupResult from "../../components/forms/traceability/packagingBarcode/PackagingBarcodeLookupResult";
import { TraceabilityPackagingBarcodeViewModel } from "../../viewmodels/traceability/TraceabilityPackagingBarcodeViewModel";

function TraceabilityPackagingBarcode(props) {
  const { logout, addSnackbar } = props;
  const {
    loading,
    transferInProgress,
    itemType,
    item,
    manufacturedProduct,
    histories,
    hasSearched,
    notFound,
    onLookupBarcode,
    openTransferLookupModal,
    isPackagingItemTransferable,
    emptyModal,
    setEmptyModelOpen,
  } = TraceabilityPackagingBarcodeViewModel(logout, addSnackbar);

  const searchRef = useRef();

  const handleSearch = () => {
    onLookupBarcode(searchRef.current?.value);
  };

  const hasResult = item != null;

  return (
    <div className="mt-2 lg:px-8">
      <div className="sm:flex sm:items-center px-4 py-5 card-custom">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Packaging Barcode Lookup
          </h1>
          <p className="mt-1 text-sm text-gray-500">
            Scan or paste a carton or pallet barcode to view full traceability
            history.
          </p>
          <div className="mt-5 flex rounded-md">
            <div className="relative flex items-stretch flex-grow focus-within:z-10">
              <input
                type="search"
                name="packagingBarcode"
                id="packagingBarcode"
                className="block w-full rounded-lg rounded-l-md pl-3 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
                placeholder="Enter carton or pallet barcode"
                ref={searchRef}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSearch();
                }}
              />
            </div>
            <button
              type="button"
              className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
              onClick={handleSearch}
            >
              <MagnifyingGlassIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </button>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="py-4 space-y-4">
          <Skeleton
            className="w-full"
            height="8rem"
            borderRadius="16px"
          ></Skeleton>
          <Skeleton
            className="w-full"
            height="7rem"
            borderRadius="16px"
          ></Skeleton>
          <Skeleton
            className="w-full"
            height="7rem"
            borderRadius="16px"
          ></Skeleton>
          <Skeleton
            className="w-full"
            height="7rem"
            borderRadius="16px"
          ></Skeleton>
        </div>
      ) : null}

      {!loading && hasResult ? (
        <PackagingBarcodeLookupResult
          itemType={itemType}
          item={item}
          manufacturedProduct={manufacturedProduct}
          histories={histories}
          onTransfer={() => openTransferLookupModal(item, itemType)}
          transferInProgress={transferInProgress}
          canTransfer={isPackagingItemTransferable(item, itemType)}
        />
      ) : null}

      {!loading && hasSearched && notFound ? (
        <div className="mt-4 card-custom rounded-xl border border-dashed border-gray-300 p-8 text-center">
          <h2 className="text-lg font-semibold text-gray-900">
            Item not found
          </h2>
          <p className="mt-2 text-sm text-gray-500">
            We could not resolve this barcode as a carton or pallet.
          </p>
        </div>
      ) : null}

      {/* {!loading && !hasResult && !hasSearched ? (
        <div className="mt-4 card-custom rounded-xl border border-gray-200 p-8 text-center">
          <h2 className="text-lg font-semibold text-gray-900">
            Ready to trace a barcode
          </h2>
          <p className="mt-2 text-sm text-gray-500">
            Enter a barcode above to load item details and timeline events.
          </p>
        </div>
      ) : null} */}

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TraceabilityPackagingBarcode),
);
